{
  "name": "consent-management",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "prebuild": "node scripts/generate-build-info.js",
    "start": "ng serve",
    "build": "ng build",
    "build:sdk:dev": "node scripts/build-sdk.js",
    "build:sdk:prod": "node scripts/build-sdk.js --production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "deploy:dev": "npm run prebuild && ng build --base-href=/ --c=preprod && npm run build:sdk:dev && cd dist/consent-management/browser && aws s3 rm s3://dev.opendata.energy --recursive && aws s3 cp ./ s3://dev.opendata.energy/ --recursive && aws cloudfront create-invalidation --distribution-id E126OZWA6FOGD4 --paths '/*'",
    "deploy:prod": "npm run prebuild && ng build --base-href=/ --c=production && npm run build:sdk:prod && cd dist/consent-management/browser && aws s3 rm s3://opendata.energy --recursive && aws s3 cp ./ s3://opendata.energy/ --recursive && aws cloudfront create-invalidation --distribution-id E33C7B35AKY5ZF --paths '/*'",
    "deploy:docs": "aws s3 sync docs/ s3://assets.perse.io/consent-wallet/ --delete --content-type text/markdown --cache-control no-cache && aws cloudfront create-invalidation --distribution-id E1PG41G28STBV7 --paths '/consent-wallet/*'"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.0",
    "@angular/cdk": "^19.2.18",
    "@angular/common": "^19.1.0",
    "@angular/compiler": "^19.1.0",
    "@angular/core": "^19.1.0",
    "@angular/forms": "^19.1.0",
    "@angular/material": "^19.2.18",
    "@angular/platform-browser": "^19.1.0",
    "@angular/platform-browser-dynamic": "^19.1.0",
    "@angular/router": "^19.1.0",
    "@popperjs/core": "^2.11.8",
    "@stripe/stripe-js": "^7.4.0",
    "aws-amplify": "^6.15.0",
    "bootstrap": "^5.3.3",
    "jwt-decode": "^4.0.0",
    "marked": "^15.0.12",
    "ngx-markdown": "^19.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.3",
    "@angular/cli": "^19.1.3",
    "@angular/compiler-cli": "^19.1.0",
    "@types/jasmine": "~5.1.0",
    "esbuild": "^0.25.8",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "terser": "^5.43.1",
    "typescript": "~5.7.2"
  }
}
